import moment from 'moment';

export const toRp = (value: number) =>
  `Rp. ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`;
export const dateToReadable = (date: string) => moment(date).format('YYYY-MM-DD HH:mm');
